const getScrollbarWidth = () => {
  var _a, _b, _c;

  if (typeof window === 'undefined') {
    return 0;
  }

  const windowInnerWidth = (_a = window === null || window === void 0 ? void 0 : window.innerWidth) !== null && _a !== void 0 ? _a : 0;
  const documentWidth = (_c = (_b = document === null || document === void 0 ? void 0 : document.documentElement) === null || _b === void 0 ? void 0 : _b.clientWidth) !== null && _c !== void 0 ? _c : 0;
  return windowInnerWidth - documentWidth;
};

export { getScrollbarWidth };
